import {
  AiFillHome,
  AiFillEye,
  AiFillEyeInvisible,
  AiOutlineSound,
} from "react-icons/ai";
import { BsInfoCircleFill, BsIncognito } from "react-icons/bs";
import { BiBook } from "react-icons/bi";
import { MdAccountTree, MdAdminPanelSettings, MdDashboard, MdHistory, MdOutlinePersonOff, MdOutlinePersonOutline } from "react-icons/md";
import { FaMapMarkedAlt, FaUser, FaFileCsv } from "react-icons/fa";
import { FiChevronDown, FiChevronUp, FiFilm } from "react-icons/fi";
import { TbBuildingCastle, TbMapPinOff, TbMapOff, TbShip, TbShipOff } from "react-icons/tb";
import { GiHeartTower, GiKnightBanner, GiLeatherBoot, GiWingedShield, } from "react-icons/gi";
import { TiSortAlphabeticallyOutline } from "react-icons/ti";
import { PiSailboat, PiTentDuotone } from "react-icons/pi";
import { RiFlagFill, RiFlagOffFill, RiLogoutBoxFill } from "react-icons/ri";


export const icons = {
  AiFillEye,
  AiFillEyeInvisible,
  AiFillHome,
  AiOutlineSound,
  BiBook,
  BsIncognito,
  BsInfoCircleFill,
  FaFileCsv,
  FaMapMarkedAlt,
  FaUser,
  FiChevronDown,
  FiChevronUp,
  FiFilm,
  GiHeartTower,
  GiKnightBanner,
  GiLeatherBoot,
  GiWingedShield,
  MdAccountTree,
  MdAdminPanelSettings,
  MdDashboard,
  MdHistory,
  MdOutlinePersonOff,
  MdOutlinePersonOutline,
  PiSailboat,
  PiTentDuotone,
  RiFlagFill,
  RiFlagOffFill,
  RiLogoutBoxFill,
  TbBuildingCastle,
  TbMapOff,
  TbMapPinOff,
  TbShip,
  TbShipOff,
  TiSortAlphabeticallyOutline,
};
